<template>
    <div class="payment-notice">
        <el-card shadow="always">
            <div class="action-container">
                <!-- 添加国际化文本样式 -->
                <p class="notice-text">{{ $t('paymentNotice') }}</p>
                <!-- 添加loading状态 -->
                <el-button
                    type="primary"
                    :disabled="countdown > 0"
                    :loading="isProcessing"
                    @click="handleComplete"
                >
                    <!-- 优化倒计时显示 -->
                    <span>
                        {{ buttonText }}
                    </span>
                </el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            countdown: 15, // 初始倒计时15秒
            timer: null // 定时器实例
        }
    },
    computed: {
        buttonText() {
            return this.countdown > 0 ? `${this.countdown} s` : this.$t('ok')
        }
    },
    mounted() {
        this.startCountdown()
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
    methods: {
        startCountdown() {
            this.timer = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--
                } else {
                    clearInterval(this.timer)
                    // 自动执行完成操作
                    // this.handleComplete()
                }
            }, 1000)
        },
        handleComplete() {
            if (this.countdown > 0) return

            // 执行后续业务逻辑，例如：
            // 1. 跳转回订单页
            // 2. 关闭当前窗口
            // 3. 调用完成接口
            this.$router.push('/account')
        }
    }
}
</script>
<style scoped>
/* 桌面端基础样式 */
.payment-notice {
    max-width: 800px;
    margin: 50px auto;
    padding: 20px;
}

.action-container {
    margin: 30px 0;
    text-align: center;
}

.notice-text {
    font-size: 18px;
    color: #666;
    margin-bottom: 25px;
    line-height: 1.6;
}

.el-button {
    min-width: 180px;
    padding: 12px 30px;
    font-size: 16px;
    border-radius: 4px;
}
/* 添加卡片内边距响应式处理 */
:deep(.el-card__body) {
    padding: 30px;
}

/* 移动端适配 */
@media (max-width: 768px) {
    .payment-notice {
        margin: 20px 10px;
        padding: 10px;
    }

    .el-card {
        border-radius: 8px;
    }

    .notice-text {
        font-size: 16px;
        margin-bottom: 20px;
        padding: 0 10px;
    }

    .el-button {
        width: 100%;
        min-width: auto;
        padding: 14px 20px;
        font-size: 15px;
    }

    /* 调整卡片内边距 */
    :deep(.el-card__body) {
        padding: 20px 15px;
    }
}

/* 小屏幕手机适配 */
@media (max-width: 480px) {
    .notice-text {
        font-size: 14px;
    }

    .el-button {
        font-size: 14px;
        padding: 12px 15px;
    }
}
</style>